import { Factory } from '../../services/Factory';
import { Status } from '../../model/project/Status';

import IHttpService = angular.IHttpService;

export interface IAdvancedViewerScope extends angular.IScope {
  project;
  filePath;
  resource;
  ngShow: boolean;
  ngHide: boolean;
  pendingChanges: { redaction: boolean };
  isLargePdf: boolean;
  showLargePdf: boolean;
  loadLargePdf: Function;
  Status;
  documentTitle: string;
  directEndorsedPdfPath: string;
}

export interface IAdvancedViewerAttributes extends angular.IAttributes {
}

export class AdvancedViewer implements angular.IDirective {
  public restrict: string = "E";
  public link: (scope: IAdvancedViewerScope, element: angular.IAugmentedJQuery, attrs: IAdvancedViewerAttributes) => void;
  public templateUrl: string;
  public maxPdfBytes: number;
  public scope = {filePath: "=ngModel", resource: "=", project: "=", ngShow: "=", ngHide: "=", pendingChanges: "=", documentTitle: "=", directEndorsedPdfPath: "="};
  public require = ["ngModel"];
  private readonly iframe;

  constructor(private projectService: app.services.project.ProjectService, resourceService: app.services.resources.ResourceService, private roleService: app.services.authentication.RoleService, auditLogService: app.services.auditing.AuditLogService, private preferenceService: app.services.user.PreferenceService, private httpService: IHttpService, private $timeout) {
    PDFViewerApplication.__setScale = PDFViewerApplication.setScale;

    this.iframe = $("#iioPrintIframe")
    this.templateUrl = "partials/review/advanced_viewer.html";
    this.maxPdfBytes = 10000000;

    this.iframe.on("load", e => {
      setTimeout(() => {
        e.currentTarget.contentWindow.focus();
        e.currentTarget.contentWindow.print();
      }, 200);
    });

    // Had to be a JQUERY event, since it"s coming from viewer.js
    $(window).on("iioprint", (e, downloadUrl) => this.handlePrint(e, downloadUrl));


    this.link = (scope: IAdvancedViewerScope) => {
      let document = (window as any).current.document;
      let printContainer = $(document.createElement("div")).attr("id", "printContainer");

      scope.Status = Status;

      $(window).on("iioprint", () => auditLogService.Audit(scope.project.id, "Print PDF", {
        resourceId: scope.resource.id,
        uri: scope.resource && scope.resource.directRedactedPdfPath ? scope.resource.directRedactedPdfPath.split('?')[0] : scope.resource.directPdfPath.split('?')[0]
      }));

      $(window).on("iiodownload", () => auditLogService.Audit(scope.project.id, "Download PDF", {
        resourceId: scope.resource.id,
        uri: scope.resource && scope.resource.directRedactedPdfPath ? scope.resource.directRedactedPdfPath.split('?')[0] : scope.resource.directPdfPath.split('?')[0]
      }));

      $(document).on("redactionsChanged", () => {
        if (scope.pendingChanges) {
          scope.pendingChanges.redaction = true
        }
      });

      $(document.getElementById("printContainer")).remove();

      printContainer.insertBefore($(document).find(".header"));

      printContainer.on("saveDocument", (e, data) => {
        scope.pendingChanges.redaction = false;

        if (data.pageRedactions.length > 0) {
          resourceService.SaveRedactions(scope.resource.projectId, scope.resource.collectionId, scope.resource.id, data.pageRedactions);
        } else {
          resourceService.DeleteRedactions(scope.resource.projectId, scope.resource.collectionId, scope.resource.id);
        }
      });

      scope.$on("fullview.closed", () => {
        PDFViewerApplication.close();
      });

      scope.$watch("filePath", () => {
        this.CheckSizeAndLoadViewer(resourceService, scope);
      });

      scope.$on("FeedService.RedactionEnd", (event, message) => {
        PDFViewerApplication.downloadUrl = message.downloadUrl;
      });

      scope.$on("fullview.search", (event, query) => {

        let cleanQuery = query.replace(/(\r?\n|\r)/gm, ""); // Strip newlines

        // First <em> to last </em>
        cleanQuery = cleanQuery.substring(cleanQuery.indexOf("<em>"), cleanQuery.lastIndexOf("</em>"));

        // Strip the highlight
        cleanQuery = cleanQuery.replace(/<\/?em>/gm, "");

        //console.log(query);
        //console.log(cleanQuery);

        PDFViewerApplication.findBar.open();
        PDFViewerApplication.findBar.findField.value = cleanQuery;
        PDFViewerApplication.findBar.highlightAll.checked = true;
        PDFViewerApplication.findBar.caseSensitive.checked = false;
        PDFViewerApplication.findBar.dispatchEvent("");
      });


        scope.loadLargePdf = () => {
          scope.showLargePdf = true;
          scope._viewerGen = (scope._viewerGen || 0) + 1;
          $timeout(() => this.LoadViewer(resourceService, scope, scope._viewerGen));
        }
      }
    }

  private async handlePrint(e, downloadUrl) {
    // Short circuit print if we don't have "manage downloads" capability
    const currentProject = this.projectService.GetCurrentProject() as any;

    if (!this.roleService.hasPermission(currentProject.roles, "MANAGE_DOWNLOADS")) {
      return;
    }

    try {
      const response = await this.httpService({
        url: downloadUrl,
        method: "GET",
        headers: {
          "Content-type": "application/pdf"
        },
        responseType: "arraybuffer"
      });


      const pdfFile = new Blob([response.data as any], {type: "application/pdf"});
      const pdfUrl = URL.createObjectURL(pdfFile);

      this.iframe.attr("src", pdfUrl);
    } catch (e) {
      console.log("Failed to print");
    }
  }

    private CheckSizeAndLoadViewer(resourceService: app.services.resources.ResourceService, scope: IAdvancedViewerScope) {
      // Always close any in-flight PDF.js load before starting a new one (or clearing).
      PDFViewerApplication.close();

    if (scope.filePath && scope.filePath.valueOf() && scope.filePath.valueOf() !== "about:blank") {

      if (scope.resource.pdfBytes > this.maxPdfBytes) {
        console.log("PDF too big, " + scope.resource.pdfBytes + ", max: " + this.maxPdfBytes);
        scope.isLargePdf = true;
        scope.showLargePdf = false;
      } else {
        scope.isLargePdf = false;
        scope.showLargePdf = false;

          scope._viewerGen = (scope._viewerGen || 0) + 1;
          this.LoadViewer(resourceService, scope, scope._viewerGen);
        }
      }
    }


    private async LoadViewer(resourceService: app.services.resources.ResourceService, scope: IAdvancedViewerScope, viewerGen: number) {
      let existingRedactions: PDFRedact[] = [];

      if (!scope.directEndorsedPdfPath) {
        const redactions = await resourceService.GetRedactions(scope.resource.projectId, scope.resource.collectionId, scope.resource.id);

        if (scope._viewerGen !== viewerGen) { return; }

      redactions?.pageRedactions?.forEach((value: any) => {
        existingRedactions.push(new PDFRedact());
        existingRedactions[existingRedactions.length - 1].pageRedactions = value.redactions;
        existingRedactions[existingRedactions.length - 1].pageNumber = value.pageNumber;
      });
    }

      const filePathValue = scope.filePath && scope.filePath.valueOf();
      if (filePathValue && filePathValue !== "about:blank") {
        PDFViewerApplication.setScale = (scale, resetAutoSettings) => {
          this.preferenceService.Set("AdvancedViewerZoomSetting", scale);
          PDFViewerApplication.__setScale(scale, resetAutoSettings);
        }

        DEFAULT_SCALE = this.preferenceService.Get("AdvancedViewerZoomSetting") ?? "auto";
        PDFViewerApplication.initializeViewer(filePathValue, existingRedactions);
      }

    if (scope.directEndorsedPdfPath) {
      PDFViewerApplication.downloadUrl = scope.directEndorsedPdfPath;
    } else if (scope.resource?.directRedactedPdfPath) {
      PDFViewerApplication.downloadUrl = scope.resource.directRedactedPdfPath;
    } else if (scope.resource) {
      PDFViewerApplication.downloadUrl = scope.resource.directPdfPath;
    }
  }
}

frontendApp.directive("iioAdvancedViewer", ["ProjectService", "ResourceService", "RoleService", "AuditLogService", "PreferenceService", "$http", "$timeout", Factory.Create(AdvancedViewer)]);
